import { Component } from '@angular/core';
import { ApiService } from './custom-material/Services/api.service';
import { UserModel, BuildingModel } from './main/Models';
import { environment } from '../environments/environment';
import { EnvService } from './custom-material/Services/env.service';
import { globalData } from './main/Models/global.model';

// import {MatIconRegistry} from '@angular/material/icon';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  ready = false;

  get userIsConnected(): boolean
  {
    return this.apiService.isConnected();
  }

  constructor(
    private apiService: ApiService,
    private gd: globalData,
    private envService: EnvService,
  ) {
    environment.baseUrl = this.envService.baseUrl;
    environment.apiBaseUrl = this.envService.apiBaseUrl;
    environment.production = this.envService.production;

    if(this.userIsConnected) this.afterLogin();
    /**
    iconRegistry.addSvgIcon(
        'country',
        sanitizer.bypassSecurityTrustResourceUrl(environment.baseUrl+'/miiar/assets/icons/flag.svg'));
    //*/
  }

  afterLogin($event=null)
  {
    this.loadBuildings().then((ready: boolean)=>{
      this.ready = true;
    });
  }

  loadBuildings()
  {
    this.gd.selectedBuildingsList = [];

    return new Promise((resolve, reject) => {

      //load own buildings and employee buildings
      let params = this.apiService.createParams({
        user: this.apiService.connectedUser.id,
        withemployees: 1
      }, 'eq');
      this.apiService.getAllFromServer('building', params)
        .then((buildings:Array<any>) => {
          for( let b in buildings) {
          	this.gd.buildings.push(new BuildingModel(buildings[b]));
          }

          if(this.gd.buildings.length==1) {
            this.gd.selectedBuildingsList.push(this.gd.buildings[0].id);
          }
          resolve(true);
        })
        .catch((err)=>{ console.warn('loadBuildings error', err); });
    });
  }

  changeRubric(event:any)
  {
    //this.gd.headerTitle = event.label;
    //this.gd.headerIcon = event.icon;
  }
}
